<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile"  @pressEnter="handleQuery":placeholder="$t('通用.输入.请输入')+$t('用户.手机号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('ID/邀请码')" prop="invitationCode">
                <a-input v-model="queryParam.invitationCode" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('ID/邀请码')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('真实姓名')" prop="realName">
                <a-input v-model="queryParam.realName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('真实姓名')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.性别')" prop="sex">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.性别')" v-model="queryParam.sex" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.SexEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="店铺名称" prop="shopIds">
                <a-select mode="multiple" v-model="queryParam.shopIds" :placeholder="'请选择店铺名称'" allow-clear>
                  <a-select-option v-for="(d, index) in shopList" :key="index" :value="d.id">{{ d.shopName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="PLUS会员等级" prop="plusLevelIds">
                <a-select mode="multiple" placeholder="请选择PLUS会员等级" v-model="queryParam.plusLevelIds" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in plusLevelList" :key="index" :value="d.id">{{ d.levelName }}</a-select-option>
                  <a-select-option :value="NOT_PLUS_VALUE">普通用户（非会员）</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="会员星级" prop="expLevel">
                <a-select placeholder="请选择会员星级" v-model="queryParam.expLevel" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in levelList" :key="index" :value="d.sort">{{ d.levelName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="用户角色" prop="userUserRole">
                <a-select placeholder="请选择用户角色" v-model="queryParam.userUserRole" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in userRoleList" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.用户状态')" prop="status">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户状态')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.TFEnum" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item :label="$t('用户.用户等级')" prop="status">-->
<!--                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户等级')" v-model="queryParam.levelId" style="width: 100%" allow-clear>-->
<!--                  <a-select-option v-for="(d, index) in levelList" :key="index" :value="d.id">{{ d.levelName }}</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:user:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:user:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
<!--        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['biz:user:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.选中导出')}}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>

      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >


        <span slot="userUserRole" slot-scope="text, record">

            <span v-if="record.userUserRole == '40'">
             {{$t('营销员')}}
           </span>
           <span v-if="record.userUserRole == '41'">
             {{$t('分销员')}}
           </span>
            <span v-if="record.userUserRole == '50'">
             {{$t('用户')}}
           </span>

        </span>




        <span slot="sex" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.SexEnum" :value="record.sex"/>
        </span>
<!--        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>-->
       <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>
        <span  slot="statusFlag" slot-scope="text, record">
          <a-switch @change="(checked) => onStatusChange(checked,record)" :checked-children="$t('正常')"
                    :un-checked-children="$t('禁用')" :checked="record.statusFlag"/>
        </span>


        <span  slot="liveFlag1" slot-scope="text, record">
          <a-switch @change="(checked) => onLiveChange(checked,record)" :checked-children="$t('是')"
                    :un-checked-children="$t('否')" :checked="record.liveFlag1"/>
        </span>

        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;" @click="handleRecordPreview(record.avatar)" alt="none"/>
          </div>
          <br>
        </template>
        <template slot="userInfo" slot-scope="text, record">
          昵称：{{ record.nickName }} <br/>
          手机号：{{ record.mobile }} <br/>
          真实姓名：{{ record.realName }} <br/>
          生日：{{ record.birthday }} <br/>
          ID/邀请码：{{ record.invitationCode }} <br/>
          <br/>
        </template>
        <template slot="userMoneyInfo" slot-scope="text, record">
          可提现余额：{{ record.money }} <br/>
          平台充值余额：{{ record.rechargeMoney }} <br/>
          充值金币：{{ record.rechargeGold }} <br/>
          收入金币：{{ record.incomeGold }} <br/>
          用户积分：{{ record.userScore }} <br/>
          <br/>
        </template>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="plusLevelName" slot-scope="text, record">
          <span v-if="record.plusLevelName" style="color: #1890ff; font-weight: bold;">{{ record.plusLevelName }}</span>
          <span v-else style="color: #999;">无</span>
        </span>

        <span slot="expLevelName" slot-scope="text, record">
          <span v-if="record.expLevelName" style="color: #fa8c16; font-weight: bold;">{{ record.expLevelName }}</span>
          <span v-else style="color: #999;">无</span>
        </span>

        <span slot="plusExpireTime" slot-scope="text, record">
          <span v-if="record.plusExpireTime">{{ record.plusExpireTime }}</span>
          <span v-else style="color: #999;">-</span>
        </span>


        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" />
          <a @click="openScoreModal(record)">
             <a-icon type="number" />增减积分
          </a>
          <a-divider type="vertical" />
          <a @click="myTeam(record)">查看我邀请的人</a>
        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :pageSizeOptions="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <userExtension-modal ref="UserExtension" @ok="getList"></userExtension-modal>

      <!-- 增减积分弹窗 -->
      <a-modal
        :visible="scoreModalVisible"
        title="增减用户积分"
        @cancel="closeScoreModal"
        :maskClosable="false"
        :footer="null"
        width="500px"
      >
        <a-form-model ref="scoreForm" :model="scoreForm" :rules="scoreRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-form-model-item label="用户名称">
            <span style="font-weight: 600">{{ scoreTargetUser?.nickName || '-' }}</span>
          </a-form-model-item>
          <a-form-model-item label="当前积分">
            <span style="color: #1890ff; font-weight: 600">{{ scoreTargetUser?.userScore || 0 }}</span>
          </a-form-model-item>
          <a-form-model-item label="调整积分" prop="score">
            <a-input-number v-model="scoreForm.score" :min="-999999" :max="999999" style="width: 100%" placeholder="正数增加，负数减少" />
            <div style="color: #999; font-size: 12px; margin-top: 4px;">正数增加积分，负数减少积分</div>
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark">
            <a-textarea v-model="scoreForm.remark" placeholder="请输入调整原因" :rows="3" />
          </a-form-model-item>
          <div style="text-align: center; border-top: 1px solid #e8e8e8; padding-top: 16px;">
            <a-space>
              <a-button type="primary" :loading="scoreLoading" @click="handleScoreSubmit">确定</a-button>
              <a-button @click="closeScoreModal">取消</a-button>
            </a-space>
          </div>
        </a-form-model>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageUser, listUser, delUser, updateUserStatus, updateLiveStatus, changeUserScore} from '@/api/biz/user'
import {getShopList} from '@/api/shop/shop'
import CreateForm from './modules/CreateForm'
import UserExtensionModal from './modules/UserExtension'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import moment from 'moment';
import { tableMixin } from '@/store/table-mixin'
import {listLevel} from "@/api/user/level";
import {updateIsStudy} from "@/api/shop/shop";
import {pageList as pagePlusLevels} from "@/api/plus/plusLevel";

/**
 * 归一化文本查询参数
 * 部分组件（labelInValue 下拉、远程搜索等）在异常形态下会把值变成对象（{value, label}），
 * 直接提交到后端会导致 String 字段反序列化失败（S5003 消息不可读），这里统一转成字符串。
 */
function normalizeText (val) {
  if (val === null || val === undefined) {
    return undefined
  }
  if (typeof val === 'string') {
    const trim = val.trim()
    return trim === '' ? undefined : trim
  }
  if (typeof val === 'number' || typeof val === 'boolean') {
    return String(val)
  }
  if (typeof val === 'object') {
    const candidateKeys = ['value', 'key', 'mobile', 'label', 'text']
    for (let i = 0; i < candidateKeys.length; i++) {
      if (typeof val[candidateKeys[i]] !== 'undefined') {
        return normalizeText(val[candidateKeys[i]])
      }
    }
  }
  return undefined
}

export default {
  name: 'User',
  components: {
    CreateForm,
    UserExtensionModal,
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      // PLUS会员等级下拉中"普通用户（非会员）"选项的特殊值
      NOT_PLUS_VALUE: '__NOT_PLUS__',
      pageSizeOptions: ['10', '20', '50', '100'],
      list: [],
      levelList: [],
      plusLevelList: [],
      shopList: [],
      userRoleList: [
        { value: 40, label: '营销员' },
        { value: 41, label: '分销员' },
        { value: 50, label: '用户' },
      ],

      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 增减积分弹窗
      scoreModalVisible: false,
      scoreLoading: false,
      scoreTargetUser: null,
      scoreForm: {
        score: null,
        remark: ''
      },
      scoreRules: {
        score: [
          { required: true, message: '请输入调整积分数', trigger: 'blur' },
          { type: 'number', message: '积分数必须为数字', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入调整原因', trigger: 'blur' }
        ]
      },
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        nickName: null,
        realName: undefined,
        sex: undefined,
        invitationCode: null,
        isNotice: null,
        status: undefined,
        shopName: undefined,
        shopIds: undefined,
        plusLevelIds: undefined,
        expLevel: undefined,
        userUserRole: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: this.$t('用户.手机号'),
        //   dataIndex: 'mobile',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户.昵称'),
        //   dataIndex: 'nickName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '用户信息',
          dataIndex: 'userInfo',
          scopedSlots: { customRender: 'userInfo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center',
        },
        // {
        //   title: this.$t('用户.性别'),
        //   dataIndex: 'sex',
        //   scopedSlots: { customRender: 'sex' },
        //   align: 'center'
        // },
        {
          title: '所属店铺',
          dataIndex: 'shopName',
          align: 'center'
        },
        {
          title:  this.$t('用户.钱包'),
          dataIndex: 'userMoneyInfo',
          scopedSlots: { customRender: 'userMoneyInfo' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('用户.角色类型'),
        //   dataIndex: 'userUserRole',
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: {customRender: 'userUserRole'},
        // },
        {
          title: this.$t('用户.用户状态'),
          dataIndex: 'statusFlag',
          scopedSlots: { customRender: 'statusFlag' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: 'PLUS会员等级',
          dataIndex: 'plusLevelName',
          scopedSlots: { customRender: 'plusLevelName' },
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: '会员星级',
          dataIndex: 'expLevelName',
          scopedSlots: { customRender: 'expLevelName' },
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: 'PLUS会员到期时间',
          dataIndex: 'plusExpireTime',
          scopedSlots: { customRender: 'plusExpireTime' },
          ellipsis: true,
          align: 'center',
          width: 150

        },
        // {
        //   title: this.$t('是否可以直播'),
        //   dataIndex: 'liveFlag1',
        //   scopedSlots: { customRender: 'liveFlag1' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户.解封时间'),
        //   dataIndex: 'unFrozenTime',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('用户.注册时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getLevelList();
    this.getPlusLevelList();
    this.getShopList();
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    onStatusChange(statusFlag, record){
      let data = {id: record.id, statusFlag: statusFlag}
      updateUserStatus(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.statusFlag = statusFlag
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },

    onLiveChange(liveFlag1, record){
      let data = {id: record.id, liveFlag: liveFlag1}
      updateLiveStatus(data).then(response => {
        if (response.success) {
          this.$message.success(
              this.$t('通用.文本.修改成功'),
              3
          );
          this.$emit('ok')
          record.liveFlag1 = liveFlag1
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      pageUser(this.buildQueryParam()).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /**
     * 构造查询/导出参数（列表查询与导出共用，避免两处传参不一致）
     * 1. 将"普通用户（非会员）"标记转换为 isNotPlus，避免污染数字类型的 plusLevelIds
     * 2. 文本参数统一归一化，避免对象/空串传给后端导致反序列化失败
     * 3. 清理空值，减少无效参数传输
     */
    buildQueryParam () {
      const params = { ...this.queryParam }
      if (params.plusLevelIds && params.plusLevelIds.includes(this.NOT_PLUS_VALUE)) {
        params.isNotPlus = true
        params.plusLevelIds = params.plusLevelIds.filter(id => id !== this.NOT_PLUS_VALUE)
        if (params.plusLevelIds.length === 0) {
          params.plusLevelIds = undefined
        }
      } else {
        params.isNotPlus = undefined
      }
      const textKeys = ['mobile', 'nickName', 'realName', 'invitationCode', 'email', 'shopName', 'keyword']
      textKeys.forEach(key => {
        params[key] = normalizeText(params[key])
      })
      Object.keys(params).forEach(key => {
        const value = params[key]
        const isEmpty = value === undefined || value === null || value === '' ||
          (Array.isArray(value) && value.length === 0)
        if (isEmpty) {
          delete params[key]
        }
      })
      return params
    },
    getLevelList () {
      listLevel().then(response => {
        this.levelList = response.data
      })
    },
    getPlusLevelList () {
      pagePlusLevels({ pageNum: 1, pageSize: 100 }).then(response => {
        this.plusLevelList = response.data.records || []
      })
    },
    getShopList () {
      getShopList({ shopType: 3 }).then(response => {
        this.shopList = response.data || []
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    myTeam(record){
      console.log('查看我邀请的人');
      console.log(this.$refs.UserExtension);
      this.$refs.UserExtension.title="查看我邀请的人";
      this.$refs.UserExtension.team(record);
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickName: undefined,
        realName: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        shopName: undefined,
        shopIds: undefined,
        plusLevelIds: undefined,
        expLevel: undefined,
        userUserRole: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/user/export', that.buildQueryParam(), `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出选中数据'),
        onOk () {
          that.download('biz/user/export', queryParam, `用户信息_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    },
    openScoreModal(record) {
      this.scoreTargetUser = record
      this.scoreForm = { score: null, remark: '' }
      this.$nextTick(() => { this.$refs.scoreForm?.clearValidate() })
      this.scoreModalVisible = true
    },
    closeScoreModal() {
      this.scoreModalVisible = false
      this.scoreTargetUser = null
      this.scoreForm = { score: null, remark: '' }
    },
    handleScoreSubmit() {
      this.$refs.scoreForm.validate(valid => {
        if (!valid) return
        if (!this.scoreForm.score) {
          this.$message.warning('请输入积分数')
          return
        }
        this.scoreLoading = true
        changeUserScore({
          userId: this.scoreTargetUser.id,
          score: this.scoreForm.score,
          remark: this.scoreForm.remark
        }).then(res => {
          if (res.code === 20001 || res.success) {
            this.$message.success('积分调整成功')
            this.closeScoreModal()
            this.getList()
          } else {
            this.$message.error(res.msg || '积分调整失败')
          }
        }).catch(() => {
          this.$message.error('积分调整失败')
        }).finally(() => {
          this.scoreLoading = false
        })
      })
    }
  }
}
</script>
